import {
  IonButton, IonButtons, IonImg, IonLabel,
} from '@ionic/react';
import classNames from 'classnames';

import ErrorImg from '@/assets/imgs/existingRfn.svg';

import styles from './ExistingRefinanced.module.scss';

interface ExistingRefinancedProps {
  handleClose: () => void;
}

export default function ExistingRefinanced({ handleClose }: ExistingRefinancedProps) {
  return (
    <div className={styles.existingRefinancedModalContainer}>
      <div className={styles.modalWrapper}>
        <div className={styles.modalHeaderWrapper}>
          <IonLabel className={styles.modalHeaderTitle}>
            Información importante
          </IonLabel>
        </div>
        <div className={styles.modalTitleWrapper}>
          <IonLabel className={styles.modalTitleRefinanced}>¡Operación ampliable!</IonLabel>
          <IonLabel className={styles.modalSubtitleRefinanced}>
            Este cliente tiene una operación ampliable, por favor regresa al menú
            principal y selecciónala para continuar.
          </IonLabel>
        </div>
        <IonImg src={ErrorImg} />
      </div>

      <IonButtons className={styles.modalBtnRefinanced}>
        <IonButton className={classNames(styles.nextButtonRefinanced, styles.nextButton)} onClick={handleClose}>
          Cerrar
        </IonButton>
      </IonButtons>
    </div>
  );
}
